import { Layout, Details, List, Create, Merge } from '@/views/customers'

export default {
  path: 'customers',
  //name: 'customers_list',
  component: Layout,
  children: [
    { path: '', redirect: { name: 'customers_list' } },
    { path: 'list', name: 'customers_list', component: List },
    {
      path: ':id',
      name: 'customer_details',
      component: Details,
      props: (route) => {
        return {
          ...route.params,
          ...{ customer_id: Number.parseInt(route.params.id, 10) || undefined }
        }
      }
    },
    {
      path: 'create',
      name: 'create_customer',
      component: Create
    },
    {
      path: 'manage',
      name: 'manage_customer',
      component: Merge,
      meta: {
        authRequired: 'true',
        groups: ['admin']
      }
    }
    // { path: 'add', component: AddEdit },
    // { path: 'edit/:id', component: AddEdit }
  ]
}
